module.exports = __webpack_public_path__ + "images/stickers/taco-robot@2x.9266ea6ca248f5fb9214.png";